import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigationBars from '../../components/HOC/withNavigationBars';
import GalleryGrid from './GalleryGrid';
import PageControl from '../../components/PageControl';
import actions from './duck/actions';
import { Button, Alert, Loader, Breadcrumbs, colors } from 'kangarootime-ui';
import PhotoUpload from './PhotoUpload';
import LightboxPhoto from '../../components/LightboxPhoto';
import DestructiveDialog from '../../components/common/DestructiveDialog';
import RaisedConatiner from '../../components/RaisedContainer';
import galleryActions from '../Gallery/duck/actions';

class ChildGallery extends Component {
  constructor (props) {
    super(props);

    this.state = {
      activeGalleryPage: 0,
      lightboxImageUrl: '',
      showFileUpload: false,
      showDeletePhotoDialog: false,
      groupImageIdToDelete: null,
      filesToUpload: [],
      showPhotoApprovalNotice: false,
      showLightbox: false,
      photosToDownload: []
    };
  }

  get breadcrumbs () {
    // return [
    //   { label: 'Dashboard', link: '/gallery' },
    //   { label: this.props.location.state.roomName, link: `/gallery/room/${this.props.match.params.room_id}` },
    //   { label: this.childName, link: null }
    // ];
    return [
      { label: 'Dashboard', link: null },
      { label: this.props.location.state.roomName, link: null },
      { label: this.childName, link: null }
    ];
  }

  get childName () {
    if (this.props.location.state.child) {
      return `${this.props.location.state.child.first_name} ${this.props.location.state.child.last_name}`;
    }

    return '';
  }

  get childId () {
    return this.props.match.params.child_id;
  }

  get numberOfPhotosInChildGallery () {
    return parseInt(this.props.location.state.child.child_photo_count, 10);
  }

  componentDidMount = () => {
    this.props.getChildGallery(this.childId);
  }

  componentDidUpdate = (prevProps, prevState) => {
    // image was successfully removed, dismiss delete dialog
    if ((prevProps.childGallery.length > this.props.childGallery.length) && this.state.showDeletePhotoDialog) {
      this.setState({ showDeletePhotoDialog: false, groupImageIdToDelete: null });
    }

    // photo was uploaded to child's gallery, hide upload dialog
    if (prevProps.uploadingPhotos && !this.props.uploadingPhotos) {
      this.setState({ showFileUpload: false, filesToUpload: [] });
      // photo also requires approval
      if (prevProps.childGallery.length === this.props.childGallery.length) {
        this.flashNotice();
      }
    }
  }

  /**
   * @param {File} file
   */
  isPhoto = file => {
    const { type } = file;
    const regex = /^image\/(png|jpg|jpeg|gif)$/;

    return regex.test(type);
  }

  /**
   * each page will contain 20 photos
   */
  totalNumberOfGalleryPages = () => Math.ceil(this.numberOfPhotosInChildGallery / 20);

  changeGalleryPage = value => {
    const { activeGalleryPage } = this.state;
    const newPage = activeGalleryPage + value;

    this.setState({ activeGalleryPage: newPage });
  }

  photosToRender = () => {
    const { activeGalleryPage } = this.state;
    const { childGallery } = this.props;
    const photos = [...childGallery];
    const indexToStartAt = activeGalleryPage * 20;
    const indexToEndAt = Math.min(indexToStartAt + 20, photos.length);

    return photos.slice(indexToStartAt, indexToEndAt);
  }

  /**
   * @param {FileList} droppedFiles
   */
  handleFileSelection = droppedFiles => {
    const { filesToUpload } = this.state;
    const droppedFilesArray = Array.from(droppedFiles);
    // remove dropped files that aren't photos
    const filesToKeep = droppedFilesArray.filter(this.isPhoto);

    let filesToUploadCopy = [...filesToUpload];
    filesToUploadCopy = [...filesToUploadCopy, ...filesToKeep];

    this.setState({ filesToUpload: filesToUploadCopy });
  }

  removeFileFromUploadGroup = indexToRemove => {
    let filesToUploadCopy = [...this.state.filesToUpload];
    filesToUploadCopy.splice(indexToRemove, 1);

    this.setState({ filesToUpload: filesToUploadCopy });
  }

  uploadPhotos = () => {
    const { filesToUpload } = this.state;

    this.props.uploadPhotos(filesToUpload, this.childId);
  }

  showDeletePhotoDialog = groupImageIdToDelete => this.setState({ showDeletePhotoDialog: true, groupImageIdToDelete });

  deletePhoto = () => {
    const { groupImageIdToDelete } = this.state;
    const childId = this.childId;

    if (groupImageIdToDelete === null) {
      return;
    }

    this.props.removeImageFromChildGallery(groupImageIdToDelete, childId);
  }

  flashNotice = () => {
    this.setState({ showPhotoApprovalNotice: true }, () => {
      setTimeout(() => this.setState({ showPhotoApprovalNotice: false }), 5000);
    });
  }

  selectPhotoForDownload = key => {
    const photosToDownloadCopy = [...this.state.photosToDownload];
    if (photosToDownloadCopy.includes(key)) {
      photosToDownloadCopy.splice(photosToDownloadCopy.indexOf(key), 1);
    } else {
      photosToDownloadCopy.push(key);
    }

    this.setState({ photosToDownload: photosToDownloadCopy });
  }

  downloadSelectedPhotos = () => {
    const filename = this.childName.replace(' ', '_');

    this.props.downloadPhotos(this.state.photosToDownload, filename);

    this.setState({ photosToDownload: [] });
  }

  render () {
    const { fetchingChildGallery, uploadingPhotos } = this.props;
    const { activeGalleryPage, showDeletePhotoDialog, showPhotoApprovalNotice, showLightbox, lightboxImageUrl } = this.state;
    const photos = this.photosToRender();

    return (
      <NavigationBars>
        <div className='flex-1 flex-columns'>
          <Loader loading={false}>
            <div className='flex-1 flex-columns'>
              { showPhotoApprovalNotice
                ? <Alert title='Photo requires approval' type='info' />
                : null
              }
              <Breadcrumbs breadcrumbs={this.breadcrumbs} />
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div>
                  <Loader loading={this.props.downloadingPhotos}>
                    { this.state.photosToDownload.length > 0 &&
                      <Button color={colors.success} onClick={this.downloadSelectedPhotos}>
                        Download Selected Photos
                      </Button>
                    }
                  </Loader>
                </div>
                <Button onClick={() => this.setState({ showFileUpload: true })}>
                  Add Photos
                </Button>
              </div>
              <RaisedConatiner animated={false} style={{ marginTop: 8 }}>
                <Loader loading={fetchingChildGallery && photos.length === 0}>
                  <GalleryGrid
                    photos={photos}
                    onPhotoClick={lightboxImageUrl => this.setState({ showLightbox: true, lightboxImageUrl })}
                    handlePhotoDeleteRequest={this.showDeletePhotoDialog}
                    selectPhoto={uri => this.selectPhotoForDownload(uri)}
                    isPhotoSelected={uri => this.state.photosToDownload.includes(uri)}
                  />
                </Loader>
                { this.numberOfPhotosInChildGallery > 20
                  ? <PageControl
                    activePage={activeGalleryPage}
                    totalNumberOfPages={this.totalNumberOfGalleryPages()}
                    onNext={() => this.changeGalleryPage(1)}
                    onPrevious={() => this.changeGalleryPage(-1)}
                  /> : null
                }
              </RaisedConatiner>
            </div>
          </Loader>
          <PhotoUpload
            uploading={uploadingPhotos}
            isOpen={this.state.showFileUpload}
            onClose={() => this.setState({ showFileUpload: false, filesToUpload: [] })}
            files={this.state.filesToUpload}
            handleFileSelection={this.handleFileSelection}
            handleUpload={this.uploadPhotos}
            removePhotoFromUploadGroup={this.removeFileFromUploadGroup}
          />
          <DestructiveDialog
            isOpen={showDeletePhotoDialog}
            onClose={() => this.setState({ showDeletePhotoDialog: false, groupImageIdToDelete: null })}
            destructiveAction={this.deletePhoto}
            title='Delete this Photo?'
            body='Are you sure you want to remove this photo?'
          />
          <LightboxPhoto
            isOpen={showLightbox}
            onClose={() => this.setState({ showLightbox: false, lightboxPhotoUri: '' })}
            imageUrl={lightboxImageUrl}
          />
        </div>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state, ownProps) {
  const { match: { params: { child_id: childId } } } = ownProps;

  return {
    childGallery: state.gallery.byChild.byId[childId] || [],
    fetchingChildGallery: state.gallery.byChild.fetchingChildGallery,
    uploadingPhotos: state.gallery.byChild.uploadingPhotos,
    centerRequiresPhotoApproval: state.gallery.overview.requiresPhotoApproval,
    downloadingPhotos: state.gallery.overview.meta.downloadingPhotos
  };
}

function mapDispatchToProps (dispatch) {
  return {
    getChildGallery: (childId) => dispatch(actions.getChildGalleryRequest(childId)),
    uploadPhotos: (files, childId) => dispatch(actions.uploadPhotosToChildGallery(files, childId)),
    removeImageFromChildGallery: (groupImageId, childId) => dispatch(actions.removeImageFromChildGalleryRequest(groupImageId, childId)),
    downloadPhotos: (keys, filename) => dispatch(galleryActions.downloadPhotosRequest(keys, filename))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChildGallery);
